import homepage from './homepage'
import message from './message'
import sign from './sign'
import signEdit from './signEdit'
import fee from './fee'
import admission from './admission'
import more from './more'
import formerFee from './formerFee'
import refund from './refund'

const user = {
  path: 'user',
  component: resolve => require(['../../../components/pages/user'], resolve),
  redirect: 'user/homepage',
  children: [
    homepage,
    message,
    ...sign,
    ...signEdit,
    ...fee,
    ...admission,
    more,
    ...formerFee,
    refund
  ]
}

export default user



// WEBPACK FOOTER //
// ./src/router/pages/user/index.js